import React from 'react';
import axios from 'axios';
import { hot } from 'react-hot-loader/root';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { Header } from './components/Header';
import { Home, Plan } from './pages';
import { Footer } from './components/Footer';
import { HelpModal } from './components/modals/HelpModal';
import { IStore, TService } from './store/types';
import { Store } from './store';
import { PlanDataModal } from './components/modals/PlanDataModal';
import StoreAction from './store/StoreAction';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { authBtnId3 } from './utils/authBtnId3';
import { APP_URL } from './utils/config';
import { ROUTE_PATH } from './utils/routes';

function App() {
  // const [loading, setLoading] = React.useState(true);
  const [id2, setId2] = React.useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { store, dispatch } = React.useContext<IStore>(Store);
  const Action = React.useCallback(() => {
    return new StoreAction(dispatch);
  }, [dispatch])();

  React.useEffect(() => {
    if (location.search) {
      const urlParams = new URLSearchParams(location.search);
      const service = urlParams.get('service');
      if (service) Action.setService(service as TService);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const checkUser = React.useCallback(
    async (token: string | null) => {
      try {
        // @ts-ignore
        const csrfToken = document.head.querySelector("[name='csrf-token']")?.content;

        const res = await axios.request({
          method: 'POST',
          headers: {
            'X-ACCESS-TOKEN': token,
            'X-CSRF-TOKEN': csrfToken || '',
          },
          url: APP_URL,
        });
        if (res.data.error) {
          dispatch(
            Action.checkUser({
              error: true,
              message: res.data.message || 'Виникла помилка',
            }),
          );
        } else {
          dispatch(Action.checkUser({ error: false, message: '' }));
        }
        dispatch(
          Action.setUser({
            isAuth: res.data.isAuth,
            isAccess: res.data.isAccess,
            isDemo: res.data.isDemo,
            token: res.data.error ? '' : token || '',
          }),
        );
      } catch (e) {
        console.log(e, 'error');
        dispatch(Action.setUser({ isAuth: false, isAccess: false, token: '', isDemo: false }));
        dispatch(Action.checkUser({ error: true, message: e ? e.toString() : '' }));
      }
    },
    [Action, dispatch],
  );

  React.useEffect(() => {
    const fnToken = async () => {
      await localStorage.clear();
      authBtnId3(
        async (token: string | null) => {
          setId2(true);
          checkUser(token);
        },
        () => {
          dispatch(Action.setUser({ isAuth: false, isAccess: false, token: '', isDemo: false }));
          localStorage.clear();
          window.location.reload();
        },
      );
    };
    if (!id2) {
      fnToken();
    }
  }, [Action, checkUser, dispatch, id2, navigate]);

  const renderApp = () => {
    if (store.user?.isAccess) {
      return (
        <>
          <Route path="/" element={<Home />} />
          <Route path={ROUTE_PATH.plan} element={<Plan />} />
        </>
      );
    }
    return <Route path="*" element={<Home />} />;
  };

  return (
    //@ts-ignore
    <DndProvider backend={HTML5Backend}>
      <div className="App">
        <Header />
        <Routes>{renderApp()}</Routes>
        <Footer />
        {store.modal.help && store.modal.open ? <HelpModal /> : null}
        {store.modal.dataPlan && store.modal.open ? <PlanDataModal /> : null}
      </div>
    </DndProvider>
  );
}

export default hot(App);
